export default __webpack_public_path__ + "static/media/Foerderer_Logos.e91cfe03.png";